import React from "react";
import IconLabelComponent from "./IconLabel.component";
import {
  Box,
  Card,
  CardContent,
  Grid,
  useTheme,
} from "@mui/material";

const FiltersComponent = ({
  width = 85,
  onChange = () => { },
  options,
  checked,
}) => {
  const theme = useTheme();

  return (
    <Card sx={{ borderRadius: 3, }}>
      <CardContent
        sx={{

          borderRadius: 3,
          backgroundColor: "rgb(41,50,60)",
          boxShadow: "0 6px 12px 0 rgb(0 0 0 / 16%)",
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          "&.MuiCardContent-root": {
            padding: 1,
          }
        }}
      >
        <Box
          component="div"
          sx={{
            minHeight: 41,
            position: "relative",
            width: width,
          }}
        >
          <Box
            component="div"
            sx={{
              position: "absolute",
              // backgroundColor: "rgba(68,65,65,0.84)",
              backgroundColor: theme.palette.primary.main,
              borderRadius: 2,
              width: 25,
              height: "100%",
              top: 2,
              right: 0,
              opacity: 0.7,
            }}
          />

          <Grid container>
            {options?.map((item, index) => (
              <Grid
                item
                xs={12}
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <IconLabelComponent
                  item={item}
                  isSelected={checked && checked[item.name]}
                  onChange={() => onChange(item)}
                  icon={item?.icon}
                  width={width - 25}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      </CardContent>
    </Card>
  );
};

export default FiltersComponent;
